export default "__VITE_ASSET__eb75c2e5__"